import ReactDOM from 'react-dom/client';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { Provider } from 'react-redux';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import rootReducer from './reducers/root';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

//MAIN
import HomeMain from './Pages/Main/Home';
import IndexMain from './Pages/Main/Index';
import AppMain from './Pages/Main/App';
import MainApi from './Pages/Main/Api/Index';
import AboutApi from './Pages/Main/Api/About';
import MainApiController from './Pages/Main/Api/Controller';
import MainApiMethod from './Pages/Main/Api/Method';


//LK
import IndexCalendar from './Pages/Lk/Calendar/Index';
import IndexProject from './Pages/Lk/Project/Index';
import IndexTask from './Pages/Lk/Task/Index';
import IndexTaskRsetting from './Pages/Lk/TaskR/Setting/Index';
import IndexTaskR from './Pages/Lk/TaskR/Tracker/Index';
import IndexBoard from './Pages/Lk/Board/Index';
import IndexCompany from './Pages/Lk/Company/Index';
import IndexParameter from './Pages/Lk/Parameter/Index';
import IndexLabel from './Pages/Lk/Label/Index';
import IndexMessages from './Pages/Lk/Messages/Index';
import IndexLk from './Pages/Lk/Index';
import EmailConfirm from './Pages/Lk/EmailConfirm';
import IndexUser from './Pages/Lk/User/Index';
import IndexSetting from './Pages/Lk/Setting/Index';
import IndexSupport from './Pages/Lk/Support/Index';
import IndexBilling from './Pages/Lk/Billing/Index';
import Test from './Pages/Test';

//SignalR
import { hubConnect } from './SignalR/Hub';
import UserBlocked from './Pages/Lk/UserBlocked';

hubConnect();

//STORE
export const store = configureStore({
  reducer: {
    ...rootReducer
  }
});

setupListeners(store.dispatch);

const root = ReactDOM.createRoot(document.getElementById('root'));
const renderApp = (Component) => {
  root.render(
    <>

      <Provider store={store}>
        <DndProvider backend={HTML5Backend}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<IndexMain />}>
                <Route index element={<HomeMain />} />

                <Route path="*" element={<div>No Found</div>} />
              </Route>

              <Route path="/api" element={<MainApi />}>
                <Route index element={<AboutApi />} />
                <Route path=":url_controller" element={<MainApiController />} />
                <Route path=":url_controller/:url_method" element={<MainApiMethod />} />
                <Route path="*" element={<div>No Found</div>} />
              </Route>

              <Route path="/lk" element={<IndexLk />}>
                <Route index element={<IndexCalendar />} />
                <Route path="calendar" element={<IndexCalendar />} />
                <Route path="project" element={<IndexProject />} />
                <Route path="task" element={<IndexTask />} />
                <Route path="messages" element={<IndexMessages />} />
                <Route path="/lk/taskR/setting" element={<IndexTaskRsetting />} />
                <Route path="/lk/taskR/current" element={<IndexTaskR />} />
                <Route path="/lk/ref/param" element={<IndexParameter />} />
                <Route path="/lk/ref/label" element={<IndexLabel />} />
                <Route path="board" element={<IndexBoard />} />
                <Route path="setting" element={<IndexSetting />} />
                <Route path="support" element={<IndexSupport />} />
                <Route path="company" element={<IndexCompany />} />
                <Route path="user" element={<IndexUser />} />
                <Route path="billing" element={<IndexBilling />} />
                <Route path="email_confirm" element={<EmailConfirm />} />
                <Route path="user_blocked" element={<UserBlocked />} />
                <Route path="test" element={<Test />} />
                <Route path="*" element={<div>No Found</div>} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Component />
        </DndProvider>
      </Provider>
    </>
  );
};

renderApp(AppMain);
